<div
	class="c-portlet u-bg-main u-shadow-mini {{ sectionclass }}"
	style="position: relative; height: 750px"
	(window:resize)="onResize($event)"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="geography-header c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini primary-color-bg"
	>
		<div class="o-stack__cell">
			<h5>{{ sectiontitle }}</h5>
		</div>
	</div>
	<div class="c-portlet__content pos-relative geography-widget" style="height: 711px">
		<div>
			<div class="map-wrapper">
				<div id="map" style="width: 100%; height: 711px"></div>
				<div id="geofence-disclaimer" class="geofence-disclaimer">
					<div class="geofence-disclaimer-section">
						<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
						<span class="geofence-disclaimer-text">Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected campaign.</span>
					</div>
				</div>
			</div>
			<!--Legend starts here-->
			<div class="map-products-container">
				<!-- <h5 class="map-products-title">Click on products to see coverage:</h5> -->
				<div class="map-products-list">
					<div
						class="map-product-item r7-map-product-item {{ legendItem.productName }}"
						*ngFor="let legendItem of updateLegendsOrder(mapObj?.legend)"
						[ngClass]="{
							'r7-map-product-item-selected': legendItem.isSelected,
							'r7-map-product-item-deselected': !legendItem.isSelected,
							'disable-button': legendItem.isDisabled
						}"
						(click)="selectedProductDetails(legendItem)"
					>
						{{ legendItem.productName }}
					</div>
				</div>
			</div>
			<!--Legend ends here-->

			<div class="map-region-container" *ngIf="polygonLayerDetails && showPolygonLayerDetailsFlag && !showMinimap">
				<div class="map-region-lift-detail-container" *ngIf="polygonLayerDetails.showLift">
					<div class="map-region-lift" *ngIf="showGeofenceLegends && polygonLayerDetails.avgLift">
						<span class="map-region-dmographic-title">Lift:</span> {{ polygonLayerDetails.avgLift }}x
					</div>
					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">Avg Home Value:</span>
						<span *ngIf="polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value"
							>${{ polygonLayerDetails.avgHomeValue | formatNumber }}</span
						>
						<span *ngIf="!polygonLayerDetails.avgHomeValue" class="map-region-dmographic-value">--</span>
					</div>

					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">Median Age:</span>
						<span *ngIf="polygonLayerDetails.avgMedianAge" class="map-region-dmographic-value">{{
							polygonLayerDetails.avgMedianAge
						}}</span>
						<span *ngIf="!polygonLayerDetails.avgMedianAge" class="map-region-dmographic-value">--</span>
					</div>
					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">Avg Income:</span>
						<span *ngIf="polygonLayerDetails.avgIncome" class="map-region-dmographic-value"
							>${{ polygonLayerDetails.avgIncome | formatNumber }}</span
						>
						<span *ngIf="!polygonLayerDetails.avgIncome" class="map-region-dmographic-value">--</span>
					</div>
					<div class="map-region-dmographic-container">
						<span class="map-region-dmographic-title">Avg # per household:</span>
						<span *ngIf="polygonLayerDetails.avgOccupancy" class="map-region-dmographic-value">{{
							polygonLayerDetails.avgOccupancy
						}}</span>
						<span *ngIf="!polygonLayerDetails.avgOccupancy" class="map-region-dmographic-value">--</span>
					</div>
				</div>
				<div class="map-region-dmographic-title" *ngIf="polygonLayerDetails?.regionName">
					<span class="map-region-dmographic-title">Location:</span>
					<span class="map-region-dmographic-value">{{ polygonLayerDetails.regionName }}</span>
				</div>
				<div class="map-region-detail-container">
					<span class="map-region-dmographic-title">Postal Code: </span>
					<span class="map-region-dmographic-value">{{ polygonLayerDetails.zip }}</span>
				</div>
				<div class="map-region-detail-container">
					<span class="map-region-dmographic-title">Population: </span>
					<span class="map-region-dmographic-value">{{ polygonLayerDetails.population }}</span>
				</div>
			</div>
			<div class="map-details-wrapper r7-map-dots" style="position: absolute" *ngIf="showGeofenceLegends">
				<div class="geo-inline">
					<div class="inline dot geofenceDots"></div>
					<div class="inline">Geofence</div>
				</div>
				<div class="geo-inline">
					<div class="inline dot recencyDots"></div>
					<div class="inline">Geo Recency</div>
				</div>
			</div>
			<div class="map-details-container" style="background-color: none">
				<div class="details-map-container">
					<div id="minimap" style="height: 196px"></div>
				</div>
				<div class="location-details">
					<div><b>Geofence Name</b></div>
					<div class="name">{{ geofenceCenterDetails ? geofenceCenterDetails.name : '' }}</div>
					<div class="metrics">
						<div class="p-2">
							<b>Impressions:</b> {{ geofenceCenterDetails ? geofenceCenterDetails.total_impression_sum : '' }}
						</div>
						<div class="p-2"><b>Clicks:</b> {{ geofenceCenterDetails ? geofenceCenterDetails.total_click_sum : '' }}</div>
						<div class="p-2">
							<b>CTR:</b> {{ geofenceCenterDetails ? geofenceCenterDetails.click_through_rate : '' }}%
						</div>
						<div class="p-2"><b>Android:</b> {{ geofenceCenterDetails ? geofenceCenterDetails.total_android : '' }}%</div>
						<div class="p-2"><b>iOS:</b> {{ geofenceCenterDetails ? geofenceCenterDetails.total_ios : '' }}%</div>
					</div>
				</div>
			</div>
			<div class="zoom-options-container">
				<div class="zoom-icon zoom-in" (click)="zoomIn()">
					<i class="fa fa-plus" aria-hidden="true"></i>
				</div>
				<div class="zoom-icon zoom-out" style="border-top: 0px" (click)="zoomOut()">
					<i class="fa fa-minus" aria-hidden="true"></i>
				</div>
			</div>
			<div *ngIf="!showLoad">
				<div
					class="lift-histogram-container"
					style="width: 100%"
					*ngIf="showGeofenceLegends && liftdistributionenabled"
				>
					<app-r7-lift-histogram
						[chartOptions]="chartOptions"
						[histogramData]="histogramData"
						[liftColor]="liftareacolor"
						[r7Histogram]="true"
						(showLiftRegions)="showLiftRegions($event)"
						[path]="path"
						(hideLiftRegions)="hideLiftRegions()"
						(toggleLiftRegions)="toggleLiftRegions($event)"
					>
					</app-r7-lift-histogram>
				</div>
			</div>
		</div>
		<div class="no-data-container" *ngIf="noData">
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
